module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_sekundaerlogo_postale_neg.4f08c358.svg";